import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-book-registration-ledger-report-briefly-officer',
  templateUrl: './book-registration-ledger-report-briefly-officer.component.html',
  styleUrl: './book-registration-ledger-report-briefly-officer.component.scss'
})
export class BookRegistrationLedgerReportBrieflyOfficerComponent {

  filterData: any[] = [];

  startDate: any;
  endDate: any;
  repName: any;
  reportType: any;
  currentDate = new Date();
   officeRepName: string[] = [];
  bookName: string[] = [];
  bookSellerName: string[] = [];
   selectedCommissionFilter: string[] = [];
  selectedComplimentaryFilter: string[] = [];

  // TOTALS
  TotalSaleCopies = 0;
  TotalReturnCopies = 0;          // ✅ ADDED
  TotalComplimentary = 0;
  TotalAmount = 0;
  TotalReceipt = 0;
  TotalCredit = 0;
  TotalPending = 0;
  TotalCommission = 0;

  constructor(
    private dialogRef: MatDialogRef<BookRegistrationLedgerReportBrieflyOfficerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;
    this.repName = this.data?.repName || '';
    this.reportType = this.data?.reportType;
     this.officeRepName = this.data?.office_rep_name || [];
    this.bookName = this.data?.book_name || [];
    this.bookSellerName = this.data?.book_seller_name || [];

     this.selectedCommissionFilter = this.data?.commissionFilter || [];
    this.selectedComplimentaryFilter = this.data?.complimentaryFilter || [];

    this.getLedgerReport();
  }

  /* ================= API CALL ================= */
  getLedgerReport(): void {
    const req = {
      start_date: this.startDate,
      end_date: this.endDate,
      rep_name: this.repName,
       office_rep_name: this.officeRepName,
      book_name: this.bookName,
      book_seller_name: this.bookSellerName,
       commissionFilter: this.selectedCommissionFilter,
      complimentaryFilter: this.selectedComplimentaryFilter
    };

    this.service.getBookRegistrationLedgerReport5(req).subscribe({
      next: (res: any) => {

        this.filterData = res?.records || [];

        // RESET TOTALS
        this.TotalSaleCopies = 0;
        this.TotalReturnCopies = 0;
        this.TotalComplimentary = 0;
        // this.TotalComlimentary
        this.TotalAmount = 0;
        this.TotalReceipt = 0;
        this.TotalCredit = 0;
        this.TotalPending = 0;
        this.TotalCommission = 0;

        /* ✅ FRONTEND TOTAL CALCULATION (TRUSTED) */
        this.filterData.forEach(d => {
          this.TotalSaleCopies += Number(d.sale_copies || 0);
          this.TotalReturnCopies += Number(d.return_copies || 0);
          this.TotalComplimentary += Number(d.complimentary_copies || 0);
           this.TotalCredit += Number(d.credit_amt || 0);
            // this.TotalCredit += Number(d.credit_amt || 0);
          this.TotalAmount += Number(d.gross_total || 0);
          this.TotalReceipt += Number(d.received_amt || 0);
          this.TotalPending += Number(d.remaining_amt || 0);
          this.TotalCommission += Number(d.commission_amt || 0);
        });

      },
      error: () => {
        this.filterData = [];
      }
    });
  }

  /* ================= PRINT ================= */
printPage(): void {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  const WindowPrt = window.open('', '', 'width=1400,height=900');
  if (!WindowPrt) return;

  WindowPrt.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          /* ===== A4 LANDSCAPE ===== */
          @page {
            size: A4 landscape;
            margin: 8mm 6mm 8mm 10mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
            color: #000;
            -webkit-font-smoothing: none;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid #000;
          }

          th, td {
            border: 1px solid #000;
            padding: 5px 6px;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
          }

          thead {
            display: table-header-group;
          }

          tr {
            page-break-inside: avoid;
          }

          tfoot {
            display: table-row-group;
            font-weight: bold;
          }

          @media print {
            .noPrint { display: none !important; }
          }
        </style>
      </head>

      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}



  /* ================= EXCEL ================= */
  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ledger');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  close(): void {
    this.dialogRef.close();
  }
}
